import { Box, Typography } from "@mui/material";

const NoAccessPage = () => {
    return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            mt: "20vh",
            gap: 2,
          }}
        >
          <img src="/no-access.svg" alt="" height={168} width={216} />
          <Typography variant="h4">Oops, no access to Bulk Label Generator.</Typography>
          <Typography>
            To request access, contact your Admin or ask in #help-mtt-hub Slack channel.
          </Typography>
        </Box>
    );



};

export default NoAccessPage;
